import get from 'lodash-es/get'

export function sameAs(path) {
  return function(rule, value, callback) {
    const target = get(rule.vm, path)
    if (target !== value) {
      callback(new Error(rule.message))
    }
    callback()
  }
}
